<template>
  <div
    id="switch"
    style="background-color:white"
    v-show="!loaded"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img
      :src="isamnet"
      style="width:100%"
      @load="onLoad"
    />
    <div class="container">
      <div id="hand" class="hand" :style="{ opacity: 1 }">
        <img
          src="https://cdn.aralego.net/rich_media/assets/scroll_icon.png"
          alt="swipe-icon"
        />
      </div>
      <figure id="blinds">
        <a
          v-for="(blind, index) in creative.blinds"
          :key="index"
          :href="blind.landing_page"
          target="_blank"
          :style="{
            'pointer-events':
              index === current_index && !gesture ? 'auto' : 'none',
          }"
        >
          <img
            v-for="i in 100"
            :key="i"
            :class="`img` + (index + 1)"
            :src="blind.image_url"
            :style="{
              opacity: index === current_index ? 1 : 0,
              clip: `rect(0px, ${(i + 1) * 3}px, 250px, ${i * 3}px)`,
            }"
          />
        </a>
      </figure>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      style="width:100%"
      @load="onLoad"
    />
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      loaded: 2,
      current_index: 0,
      next_index: 0,
      action: "next",
      is_change_img: false,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if(domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg2.png'
      } else {
        isAmnet += '/banner/bg1.png'
      }
      return isAmnet
    }
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    const container = document.querySelector(".container");

    this.touchEnd = () => this.handleEnd();
    this.touchMove = (x, y) => this.handleMove(x, y);
    this.addEvent(container, "mouseover", this.removeHand, { once: true });
    this.addEvent(container, "touchstart", this.removeHand, { once: true });
    this.handleTouch(container);
  },
  mixins: [mixPreview, mixMobile],
  methods: {
    handleEnd() {
      if (this.current_index === this.next_index) return;
      
      const current_imgs = document.querySelectorAll(
        `.img` + (this.current_index + 1)
      );
      const next_imgs = document.querySelectorAll(
        `.img` + (this.next_index + 1)
      );
      for (var i = 0; i < 100; i++) {
        if (this.is_change_img) {
          current_imgs[i].style.opacity = 0;
          next_imgs[i].style.opacity = 1;
        } else {
          current_imgs[i].style.opacity = 1;
          next_imgs[i].style.opacity = 0;
        }

        current_imgs[i].style.transform = "scaleY(1)";
        next_imgs[i].style.transform = "scaleY(1)";
      }
      if (this.is_change_img) this.current_index = this.next_index;
      else this.next_index = this.current_index;
    },
    handleMove(x, y) {
      if (this.gesture === "up" || this.gesture === "down") return;

      const rect = document.querySelector(".container").getBoundingClientRect();
      const n = Math.round((x - rect.x) / 3);
      if (n < 0 || n > 100) return;

      if (this.next_index === this.current_index) {
        const len = this.creative.blinds.length;
        this.action = this.gesture === "left" ? "next" : "prev";
        this.next_index =
          this.action === "next"
            ? (this.current_index + 1) % len
            : (len + this.current_index - 1) % len;
      }
      this.is_change_img =
        (this.action === "next" && this.gesture === "left" && n < 50) ||
        (this.action === "prev" && this.gesture === "right" && n > 50);

      const current_imgs = document.querySelectorAll(
        `.img` + (this.current_index + 1)
      );
      const next_imgs = document.querySelectorAll(
        `.img` + (this.next_index + 1)
      );
      for (var i = 0; i < 100; i++) {
        const dist = Math.abs(i - n);
        if (dist <= 30) {
          current_imgs[i].style.transform =
            "scaleY(" + (0.85 + 0.005 * dist) + ")";
          next_imgs[i].style.transform =
            "scaleY(" + (0.85 + 0.005 * dist) + ")";
        } else {
          current_imgs[i].style.transform = "scaleY(1)";
          next_imgs[i].style.transform = "scaleY(1)";
        }
        if (
          (this.action === "next" && i < n) ||
          (this.action === "prev" && i > n)
        ) {
          current_imgs[i].style.opacity = 0 + 0.07 * dist;
          next_imgs[i].style.opacity = 0;
        } else {
          current_imgs[i].style.opacity = 0;
          next_imgs[i].style.opacity = 0 + 0.07 * dist;
        }
      }
    },
    removeHand() {
      const hand = document.querySelector(".hand");
      if (hand) {
        var fadeEffect = setInterval(function() {
          if (!hand.style.opacity) {
            hand.style.opacity = 1;
          }
          if (hand.style.opacity > 0) {
            hand.style.opacity -= 0.1;
          } else {
            clearInterval(fadeEffect);
            hand.remove();
          }
        }, 200);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.container
  width: 300px
  height: 250px
  margin: 10px auto
  position: relative
  .hand
    width: 50px
    height: 50px
    border-radius: 50%
    background: rgba(0, 0, 0, 0.7)
    position: absolute
    z-index: 999
    display: -webkit-box
    display: -ms-flexbox
    display: flex
    -webkit-box-align: center
    -ms-flex-align: center
    align-items: center
    -webkit-box-pack: center
    -ms-flex-pack: center
    justify-content: center
    top: 130px
    right: 43%
    -webkit-animation: handMove 1s linear 0s infinite alternate
    animation: handMove 1s linear 0s infinite alternate
    img
      width: 70%
      opacity: 1
  #layer
    position: absolute
    top: 0
    width: 300px
    height: 250px
    z-index: 998
    cursor: pointer
  figure
    margin: 0
    position: relative
    -webkit-perspective: 1000px
    perspective: 1000px
    -webkit-transform-style: preserve-3d
    transform-style: preserve-3d
    max-width: 1000px
    padding-bottom: 56.25%
    img
      top: 0
      left: 0
      position: absolute
      -webkit-transition: all 0s ease 0s
      -o-transition: all 0s ease 0s
      transition: all 0s ease 0s
      width: 300px

@include keyframes(handMove)
  0%
    -webkit-transform: translateX(-50px)
    transform: translateX(-50px)
  100%
    -webkit-transform: translateX(50px)
    transform: translateX(50px)
</style>
